import { _delete, _get, _post, _put } from "lib/rest";

//channel talk
export const getChannelTalk = async (pid: number) =>
  await _get(`/sentiment/project/${pid}/channels/channel-talk/`);

export const issueChannelTalk = async (pid: number) =>
  await _post(`/sentiment/project/${pid}/channels/channel-talk/`);

export const deleteChannelTalk = async (pid: number) =>
  await _delete(`/sentiment/project/${pid}/channels/channel-talk/`);

//google play
export const getGooglePlay = async (pid: number) =>
  await _get(`/sentiment/project/${pid}/channels/google-play/`);

export const issueGooglePlay = async (
  pid: number,
  data: { id: string; hl: string }
) => await _post(`/sentiment/project/${pid}/channels/google-play/`, data);

export const deleteGooglePlay = async (pid: number) =>
  await _delete(`/sentiment/project/${pid}/channels/google-play/`);

export const renewGooglePlay = async (pid: number) =>
  await _put(`/sentiment/project/${pid}/channels/google-play/`);

//app store
export const getAppStore = async (pid: number) =>
  await _get(`/sentiment/project/${pid}/channels/app-store/`);

export const issueAppStore = async (
  pid: number,
  data: { name: string; country: string }
) => await _post(`/sentiment/project/${pid}/channels/app-store/`, data);

export const deleteAppStore = async (pid: number) =>
  await _delete(`/sentiment/project/${pid}/channels/app-store/`);

export const renewAppStore = async (pid: number) =>
  await _put(`/sentiment/project/${pid}/channels/app-store/`);
